import { Group, UnstyledButton } from '@mantine/core';
import { IconClose } from 'ui-icons';

import { Badge } from '../../../../DataDisplay/Badge/Badge';

type TableSearchBadgesProps = {
  search: {
    label: string;
    value: string;
    id: string;
  }[];
  onClick: (label: string) => void;
};

interface SearchBadgeProps {
  label: string;
  value: string;
  onClick: () => void;
}

const SearchBadge = ({ label, value, onClick }: SearchBadgeProps) => {
  return (
    <UnstyledButton onClick={onClick}>
      <Badge
        type="neutral"
        variant="filled"
        rightSection={
          <IconClose
            size="12px"
            style={{
              cursor: 'pointer',
            }}
          />
        }
      >
        {label}
        {value && ` > ${value}`}
      </Badge>
    </UnstyledButton>
  );
};

const SearchBadges = ({ search, onClick }: TableSearchBadgesProps) => {
  return (
    <Group gap={'xs'}>
      {search.map((search) => (
        <SearchBadge
          key={search.id}
          label={search.label}
          value={search.value}
          onClick={() => onClick(search.id)}
        />
      ))}
    </Group>
  );
};

export { SearchBadges };
